import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const HtmlContextWidget: WidgetRegistryEntry = {
  name: "ContextHtml",
  configuration: () => import("./configuration").then((m) => m.HtmlContextConfiguration),
  component: () => import("./html-context-widget.component").then((m) => m.HtmlContextWidgetComponent)
};
